module.exports = __webpack_public_path__ + "static/media/Dragon Tiger Lion.0f8c9cfa.jpg";